import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextField } from '@carsys/form'
import { IconButton, InputAdornment, Tooltip } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'

export interface ArticlesCodesInputProps {
  name: string
  type: string
  index: number
  remove: <T>(index: number) => T | undefined
}

export const ArticlesCodesInput: React.FC<ArticlesCodesInputProps> = ({ name, type, index, remove }) => {
  const { t } = useTranslation()
  const handleOnClick = () => {
    remove(index)
  }

  return (
    <TextField
      required
      data-testid='article-code-input'
      fullWidth
      type={type}
      name={`${name}`}
      label={t('productgroup.code')}
      sx={{ mb: 2, '&:last-of-type': { mb: 0 } }}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <Tooltip title={`${t('global.delete')}`}>
              <IconButton onClick={handleOnClick} data-testid='delete-article-code-btn'>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        )
      }}
    />
  )
}
export default React.memo(ArticlesCodesInput)
